import { render } from "./chatbotPopup.vue?vue&type=template&id=4de4d513&scoped=true&ts=true"
import script from "./chatbotPopup.vue?vue&type=script&lang=ts"
export * from "./chatbotPopup.vue?vue&type=script&lang=ts"

import "./chatbotPopup.vue?vue&type=style&index=0&id=4de4d513&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de4d513"]])

export default __exports__